import { Table as AntdTable } from 'antd'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'

const Table = ({ columns, data, dataSource, onRowClick, onRow, scroll = { x: 'max-content' }, ...otherProps }) => {
    const tableRef = useRef()

    return (
        <AntdTable
            columns={columns}
            dataSource={dataSource ?? data}
            ref={tableRef}
            rowKey="id"
            onRow={onRow ?? (onRowClick ? (record, rowIndex) => ({
                onClick: (event) => {
                    if (event.target.closest('input[type="checkbox"], .ant-checkbox, .ant-checkbox-wrapper')) {
                        return
                    }
                    event.preventDefault()
                    onRowClick?.(rowIndex, record)
                },
            }) : undefined)}
            scroll={scroll}
            {...otherProps}
        />
    )
}

Table.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    data: PropTypes.arrayOf(PropTypes.object),
    dataSource: PropTypes.arrayOf(PropTypes.object),
    onRowClick: PropTypes.func,
    onRow: PropTypes.func,
    scroll: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
}

export default Table
